"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.features = void 0;
exports.features = [
    'ai-chat',
    'content-hub',
    'preview',
    'library',
    'search',
    'wallet',
    'learner-search',
    'content-retirement',
];
